import React from 'react';
import clsx from 'clsx';
import Button from 'pages/Dashboard/components/Button';
import {
  ThresholdOption,
} from 'pages/Dashboard/pages/Dashboard/RTM/ThresholdSettings/thresholdUiConfig';

type Props = {
  value: number;
  options: ThresholdOption[];
  onChange: (value: number) => void;
  variant: 'watch' | 'needsReview';
  disabled?: boolean;
};

export default function ThresholdOptionGroup({
  value,
  options,
  onChange,
  variant,
  disabled,
}: Props) {
  return (
    <div className="flex flex-wrap rounded !bg-gray-50 border border-gray-100">
      {options.map((option) => {
        const isSelected = value === option.value;
        return (
          <Button
            key={option.value}
            type="button"
            variant="text"
            disabled={disabled}
            onClick={() => { onChange(option.value); }}
            className={clsx(
              '!min-w-[40px] !h-9 !px-3 !text-xs !font-medium !normal-case !shadow-none !border-solid',
              {
                '!rounded': isSelected,
                '!bg-amber-50 !text-amber-700 !border !border-amber-200': variant === 'watch' && isSelected,
                '!bg-red-50 !text-red-700 !border !border-red-200 hover:!bg-red-100': variant === 'needsReview' && isSelected,
                '!text-gray-600 hover:!bg-gray-100 hover:!rounded !border-y-0 !rounded-none': !isSelected,
              },
            )}
          >
            {option.label}
          </Button>
        );
      })}
    </div>
  );
}
